<div class="modal-wrapper" [class.modal-wrapper--has-hint]="!!inputHint">
  <!-- Header con botón close flotante y título -->
  <div class="modal-header">
    <h2 class="h6_500 modal-title" mat-dialog-title>
      {{ title | translate }}
    </h2>
    <common-icon-button
      class="modal-close-button"
      variant="plain"
      icon="close"
      iconSet="material-icons-outlined"
      ariaLabel="Close"
      color="weak"
      type="filled"
      size="small"
      [stopClickPropagation]="true"
      (output)="onEventClose()"
    ></common-icon-button>
  </div>

  <!-- Contenido del modal -->
  <mat-dialog-content class="modal-content">
    <form [formGroup]="form" class="modal-form">
      <mat-form-field appearance="outline" class="modal-form-field">
        <mat-label>{{ inputLabel | translate }}</mat-label>
        <span matPrefix *ngIf="prefixText" class="munily-input-affix munily-input-affix--prefix">{{ prefixText }}</span>
        <input
          matInput
          [attr.inputmode]="inputModeAttr"
          [formControl]="inputControl"
          [placeholder]="inputPlaceholder | translate"
        >
        <span matSuffix *ngIf="suffixText" class="munily-input-affix munily-input-affix--suffix">{{ suffixText }}</span>
        <mat-hint *ngIf="inputHint">{{ inputHint | translate }}</mat-hint>
        <mat-error *ngIf="inputControl.hasError('pattern')">
          {{ 'areasV2.newArea.validation.invalidNumber' | translate }}
        </mat-error>
        <mat-error *ngIf="inputControl.hasError('numericMin')">
          {{ 'areasV2.newArea.validation.numericMin' | translate: { min: inputControl.getError('numericMin')?.min } }}
        </mat-error>
        <mat-error *ngIf="inputControl.hasError('numericMax')">
          {{ 'areasV2.newArea.validation.numericMax' | translate: { max: inputControl.getError('numericMax')?.max } }}
        </mat-error>
      </mat-form-field>

      <app-common-checkbox
        *ngIf="checkboxOption && checkboxControl"
        type="check_box"
        [labelKey]="checkboxOption.labelKey"
        labelPosition="after"
        [formControl]="checkboxControl"
      ></app-common-checkbox>
    </form>
  </mat-dialog-content>

  <!-- Acciones del modal -->
  <mat-dialog-actions class="modal-actions">
    <common-buttons-outlined
      [label]="labelButtonCancel | translate"
      [disabled]="loading" 
      [iconPosition]="false" 
      (output)="onEventCancel()">
    </common-buttons-outlined>

    <common-buttons-filled
      [label]="labelButtonSave | translate"
      [disabled]="loading || !form.valid" 
      [iconPosition]="false" 
      (output)="onEventSave()">
    </common-buttons-filled>
  </mat-dialog-actions>
</div>